import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dataForSeo = defineConnector({
  identifier: "dataForSeo",
  name: "DataForSEO",
  tagLine: "Search and marketing data APIs",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.dataforseo\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.login,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open your [DataForSEO API access page](https://app.dataforseo.com/api-access) and copy the API login and password. DataForSEO uses HTTP Basic authentication for all API requests.",
        },
      ],
    },
    {
      title: "Enter your DataForSEO credentials",
      items: [
        {
          kind: "input",
          label: "API login",
          required: true,
          target: { kind: "secrets", field: "login" },
        },
        {
          kind: "input",
          label: "API password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.dataforseo.com/v3/business_data/google/locations",
  },
});
